import React, { Component } from 'react';
import { Loader } from './Loading';
import { Table, TableRow, TableCell, TableBody, TableHead, TablePagination } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import grey from '@material-ui/core/colors/grey';
import UserAdminRow from '../components/subscriptions/UserAdminRow';
import ListDeleteButton from './ListDeleteButton';


/**
 * Component that displays a paginated list of items
 * as a table.
 * Supposed to receive pagination data from paginate reducer
 */

class PaginatedList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      rowsPerPage: props.rowsPerPage || 10,
      currentPage: props.currentPage || 0
    }
  }

  load(props = this.props) {
    const {
      handleLoadPage
    } = props;
    const { 
      rowsPerPage 
    } = this.state;

    // loads first page
    handleLoadPage(rowsPerPage);
  }

  componentWillMount() {
    this.load()
  }

  componentWillReceiveProps( newProps ) {
    if( newProps.changeKey !== this.props.changeKey ) {
      this.load(newProps);
    }
  }

  /**
   * Called when the page changes (user clicked on "next page" link)
   * @param {Integer} currentPage Page to navigate to
   */
  handleChangePage(currentPage) {

    const {
      handleLoadPage,
      pagination
    } = this.props;

    this.setState({ currentPage });
    const page = pagination.pages[currentPage];
    if (page) {
      handleLoadPage(this.state.rowsPerPage, page.token);
    }
  }

  /**
   * Called when the users changes the number of rows per page
   * @param {Event} e 
   */
  handleChangeRowsPerPage(e) {
    const rowsPerPage = e.target.value;
    this.setState({ rowsPerPage }, _ => this.handleChangePage(this.state.currentPage));
  }

  handleRemoveItem(item, currentPage) {
    const {
      pagination,
      handleLoadPage,
      handleRemove
    } = this.props;

    this.setState({currentPage});
    const page = pagination.pages[currentPage];
    if (page) {
      handleRemove(item)
      .then(_=>handleLoadPage(this.state.rowsPerPage, page.token));
    } 
  }

  handleAddItem(item, currentPage) {
    const {
      pagination,
      handleLoadPage,
      handleAdd
    } = this.props;

    this.setState({currentPage});
    const page = pagination.pages[currentPage];
    if (page) {
      handleAdd(item)
      .then(_=>handleLoadPage(this.state.rowsPerPage, page.token));
      
    } 
  }

  render() {
    const {
      // boolean used in case of domain tab display
      isDomain,
      // boolean used in case of user tab diplay
      isUser,
      // owner of the subscription, used in Users Tab
      owner,
      // title and message displayed in confirmDialog related to the ListDeleteButton
      confirmTitle,
      confirmMessage,
      subscription,
      // pagination data, as formatted by paginate reducer
      pagination,
      // optional array of items from which to pick items by id
      data,
      // what to display when no item is shown
      noItem = "Nothing.",
      // columns names
      columns = [],
      // Row component
      Row
    } = this.props;

    if (!pagination) {
      return <Loader />
    }

    let { currentPage, rowsPerPage } = this.state;

    const page = pagination.pages[currentPage];

    // base is the repository of items to display
    // FIXME: move to container
    const base = data || pagination.items;

    if (!page || !base) {
      return <Loader />;
    }

    const ids = page.ids || [];
    let items = [];
    let admin = {};
    let isAdminUsingLicence = isUser && subscription.ownerHasLicence;
    if (isUser) {
      admin = owner;
    }
    items = ids
      .map(id => base[id])
      .filter(item => !!item); // deleted items
    
    const rows = items
      .map(item => {
        const deleteButton = <ListDeleteButton 
                                title={confirmTitle} 
                                message={confirmMessage} 
                                working={!!item.deleting? item.deleting : false} 
                                handleRemove={()=>this.handleRemoveItem(item, this.state.currentPage)}
                              /> 
        return Row(item, deleteButton)
      })
      .slice(0, rowsPerPage);

    const isEmpty = rows.length === 0;

    // push empty rows in case there are fewer rows than rows per page
    // this avoids the view changing height when changing page
    while (rows.length < rowsPerPage) {
      rows.push(
        <TableRow key={"empty_" + rows.length} style={{ visibility: "hidden" }}>
          {isEmpty 
            ? <TableCell style={{ borderColor: "transparent" }}></TableCell>
            : columns.map((c, i) => <TableCell style={{ borderColor: "transparent" }} key={i}></TableCell>)}
        </TableRow>
      )
    }

    return (
      <Table>
        <TableHead>
          {(isDomain)
            ? null
            :<TableRow >
              <TablePagination
                rowsPerPageOptions={[rowsPerPage]}
                count={pagination.totalCount || 0}
                rowsPerPage={rowsPerPage}
                page={currentPage}
                onChangePage={(e, page) => this.handleChangePage(page)}
                onChangeRowsPerPage={e => this.handleChangeRowsPerPage(e)}
                labelRowsPerPage={
                  <FormattedMessage id='pagination.labelRowsPerPage' />
                }
                labelDisplayedRows={
                  ({from,to,count}) => {
                    const isFirstPage = currentPage === 0;
                    if(isAdminUsingLicence) {
                      count += 1;
                      to += 1;
                      if(!isFirstPage) {
                        from += 1;
                      }
                    }
                    return <FormattedMessage 
                      id='pagination.labelDisplayedRows'
                      values={{from,to,count}}
                    />
                  }
                }
              />
            </TableRow>
          }
          {!isUser &&
            <TableRow style={isDomain? {backgroundColor: grey[200]} : null}>
              {(isEmpty && isDomain) 
                ? null
                : isEmpty
                  ? (<TableCell>{noItem}</TableCell>)
                  :(columns.map((column, i) => <TableCell key={i}>{column}</TableCell>))
              }
            </TableRow>
          }
        </TableHead>
        <TableBody>
          {(isUser && currentPage===0) && 
            <UserAdminRow 
              user={admin}
              subscription={subscription}
              switchOn={isAdminUsingLicence}
              handleAddAdmin={() => this.handleAddItem(admin, this.state.currentPage)}
              handleRemoveAdmin={() => this.handleRemoveItem(admin, this.state.currentPage)}
            />
          }
          {rows}
        </TableBody>
      </Table>
    );
  }
}

export default PaginatedList;


// WEBPACK FOOTER //
// ./src/components/PaginatedList.js